import { forwardRef } from "react"
import { Skeleton, SkeletonProps, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"

export const ImageSkeletonCard = forwardRef<HTMLSpanElement, SkeletonProps>(
  ({ sx = {}, ...props }, ref) => {
    const theme = useTheme()
    const { styleOverrides = {} } =
      theme.components?.[`ImageSkeletonCard`] || {}
    const { root } = styleOverrides
    return (
      <Skeleton
        sx={deepmerge(root, sx)}
        variant="rounded"
        ref={ref}
        {...props}
      />
    )
  }
)
